// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenu_wrapper__99ZlA","container":"MobileMenu_container__omH3o"};